module.exports = __webpack_public_path__ + "static/media/img_resourceforyou-General_Tips.80d3b000.png";